// analyticsService.js
import config from "../config";

// Generate or retrieve the session ID from localStorage
export async function getSessionId() {
  let sessionId = localStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem("sessionId", sessionId);
  }
  return sessionId;
}

// start session
export async function startSession(userId = null) {
  const sessionId = await getSessionId();
  console.log("starting session for sessionId", sessionId);
  fetch(`${config.apiUrl}/analytics/start-session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      session_id: sessionId,
      user_id: userId,
    }),
  })
  .catch((err) => console.error("Analytics error:", err));
  return sessionId;
}

// Example: Track a page view
export async function trackPageView(userId = null, pageUrl) {
  console.log("sending post request to analytics/pageview")
  const sessionId = await getSessionId();
  fetch(`${config.apiUrl}/analytics/pageview`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      session_id: sessionId,
      user_id: userId,
      page_url: pageUrl
    }),
  }).catch((err) => console.error("Analytics error:", err));
}

export async function trackEvent(userId, eventType, eventDetails = {}) {
  console.log("event details: ", eventDetails);
  try {
    const sessionId = await getSessionId();
    await fetch(`${config.apiUrl}/analytics/log-event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sessionId,
        user_id: userId,
        event_type: eventType,
        event_details: eventDetails,
        page_url: eventDetails.page_url || null,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch (error) {
    console.error("Failed to track event:", error);
  }
}